import React, { useMemo } from 'react'
import styled from 'styled-components'
import FileRow from './file-row'
import Divider from '../divider'
import { useDocumentsConfig } from '../../contexts/DocumentsConfigContext'
import ArchivedFiles from './archived-files'

const ContainerElement = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  align-items: center;
`

const ColumnHeaderElement = styled.p`
  font-weight: bold;
  font-size: 0.9rem;
  margin: 0.5rem 0;
`

const DividerWrapper = styled.div`
  grid-column: span 3;
`

function Files({ documentId, files }) {
  const { hideArchivedFiles } = useDocumentsConfig()

  const notArchivedFiles = useMemo(
    () => files.filter((file) => !file.archived),
    [files]
  )

  const archivedFiles = useMemo(
    () => files.filter((file) => file.archived),
    [files]
  )

  const showDivider = notArchivedFiles.length > 0 && archivedFiles.length > 0

  return (
    <ContainerElement>
      <ColumnHeaderElement>Document</ColumnHeaderElement>
      <ColumnHeaderElement>Upload time</ColumnHeaderElement>
      <ColumnHeaderElement>Uploaded by</ColumnHeaderElement>
      {notArchivedFiles.map((file) => (
        <FileRow key={file.rid} file={file} documentId={documentId} />
      ))}
      {!hideArchivedFiles && (
        <>
          {showDivider && (
            <DividerWrapper>
              <Divider />
            </DividerWrapper>
          )}
          <ArchivedFiles documentId={documentId} files={archivedFiles} />
        </>
      )}
    </ContainerElement>
  )
}

export default Files
